import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  InputType,
  ValidationRule,
  FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_102_add_vehicle: any[] = [
    {
        "componentType": "screenGroup",
        "title": "Add Vehicle",
        "style": {
            "padding": 10
        },
        "childComponents": [
            {
                "componentType": "form",
                "Name": "Vehicle_Add",
                "TableName": "vehicle_details",
                "columnNumber": "m1 t1 w3",
                "style": {
                    "direction": "column"
                },
                "Fields": [
                    {
                        "componentType": "searchableDropdown",
                        "name": "s_select_vehicle_make",
                        "BindValue": "s_select_vehicle_make",
                        "Label": "Vehicle make",
                        "placeholder": "",
                        "IsMandatory": true,
                        "LookupName": "vehicle_make",
                        "options": [],
                        "searchable": true,
                        "clearable": true,
                        "Json_Attribute": "vehiclemake",
                        "validation": [
                            {
                                "rule": "required",
                                "message": "Vehicle make is required"
                            }
                        ]
                    },
                    {
                        "componentType": "selectDropdown",
                        "name": "s_select_vehicletype",
                        "BindValue": "s_select_vehicletype",
                        "Label": "Vehicle type",
                        "placeholder": "",
                        "IsMandatory": true,
                        "LookupName": "vehicletype",
                        "parentField": "s_select_vehicle_make",
                        "options": [],
                        "Json_Attribute": "vehicletype",
                        "validation": [
                            {
                                "rule": "required",
                                "message": "Vehicle type is required"
                            }
                        ]
                    },
                    {
                        "componentType": "searchableDropdown",
                        "name": "select_customer",
                        "BindValue": "select_customer",
                        "Label": "Customer",
                        "placeholder": "",
                        "IsMandatory": true,
                        "LookupName": "customers",
                        "options": [],
                        "searchable": true,
                        "clearable": true,
                        "Json_Attribute": "customer_id",
                        "PopupScreenId": "123"
                    },
                    {
                        "componentType": "selectDropdown",
                        "name": "s_search_country",
                        "BindValue": "s_search_country",
                        "Label": "Country",
                        "placeholder": "",
                        "IsMandatory": false,
                        "LookupName": "country",
                        "defaultValue": "United Arab Emirates",
                        "options": [],
                        "Json_Attribute": "platesource",
                        "BindParent": {
                            "select_customer": "country"
                        }
                    },
                    {
                        "componentType": "searchableDropdown",
                        "name": "s_search_platecode",
                        "BindValue": "s_search_platecode",
                        "Label": "Emirates/State",
                        "placeholder": "",
                        "IsMandatory": false,
                        "LookupName": "state",
                        "parentField": "s_search_country",
                        "options": [],
                        "searchable": true,
                        "clearable": true,
                        "Json_Attribute": "platecode",
                        "BindParent": {
                            "select_customer": "states"
                        }
                    },
                    {
                        "componentType": "textField",
                        "name": "txt_reg_no",
                        "BindValue": "txt_reg_no",
                        "Label": "Reg No.",
                        "placeholder": "",
                        "IsMandatory": true,
                        "inputType": "text",
                        "disabled": false,
                        "Json_Attribute": "reg_no",
                        "validation": [
                            {
                                "rule": "required",
                                "message": "Registration number is required"
                            }
                        ]
                    },
                    {
                        "componentType": "textField",
                        "name": "txt_enginesize",
                        "BindValue": "txt_enginesize",
                        "Label": "Engine number",
                        "placeholder": "",
                        "IsMandatory": false,
                        "inputType": "text",
                        "Json_Attribute": "engine_no"
                    },
                    {
                        "componentType": "textField",
                        "name": "txt_chasisno",
                        "BindValue": "txt_chasisno",
                        "Label": "Chassis number",
                        "placeholder": "",
                        "IsMandatory": true,
                        "inputType": "text",
                        "Json_Attribute": "chasis_no",
                        "validation": [
                            {
                                "rule": "required",
                                "message": "Chassis number is required"
                            },
                            {
                                "rule": "minLength",
                                "value": 17,
                                "message": "The Chassis number should be 17 characters long"
                            },
                            {
                                "rule": "maxLength",
                                "value": 17,
                                "message": "The Chassis number should be 17 characters long"
                            }
                        ]
                    },
                    {
                        "componentType": "selectDropdown",
                        "name": "select_vehiclecolor",
                        "BindValue": "select_vehiclecolor",
                        "Label": "Colour",
                        "placeholder": "",
                        "IsMandatory": false,
                        "LookupName": "color",
                        "options": [],
                        "Json_Attribute": "vehicle_color"
                    },
                    {
                        "componentType": "textField",
                        "name": "txt_ModelYear",
                        "BindValue": "txt_ModelYear",
                        "Label": "Model",
                        "placeholder": "",
                        "IsMandatory": true,
                        "inputType": "text",
                        "Json_Attribute": "model_year",
                        "validation": [
                            {
                                "rule": "required",
                                "message": "Model is required"
                            },
                            {
                                "rule": "maxCurrentYear",
                                "message": "Enter a valid year (YYYY) not later than the current year"
                            }
                        ],
                        "maxLength": 4
                    },
                    {
                        "componentType": "selectDropdown",
                        "name": "plate_source",
                        "BindValue": "platesource_no",
                        "Label": "Plate Source",
                        "placeholder": "",
                        "IsMandatory": false,
                        "LookupName": "plate_source",
                        "options": [],
                        "Json_Attribute": "platesource_no"
                    },
                    {
                        "componentType": "selectDropdown",
                        "name": "plate_code",
                        "BindValue": "platecode_no",
                        "Label": "Plate Code",
                        "placeholder": "",
                        "IsMandatory": false,
                        "LookupName": "plate_code",
                        "options": [],
                        "Json_Attribute": "platecode_no"
                    },
                    {
                        "componentType": "files",
                        "name": "file_mulkkiya",
                        "BindValue": "file_mulkkiya",
                        "Label": "Mulkkiya",
                        "placeholder": "",
                        "IsMandatory": false,
                        "Json_Attribute": "mulkkiya_attachment",
                        "IsVerticalView": true
                    },
                    {
                        "componentType": "files",
                        "name": "file_others",
                        "BindValue": "file_others",
                        "Label": "Others",
                        "placeholder": "",
                        "IsMandatory": false,
                        "Json_Attribute": "others_attachment",
                        "IsVerticalView": true
                    }
                ]
            },
            {
                "componentType": "button",
                "name": "Save",
                "onPressAction": "save",
                "style": {
                    "backgroundColor": ""
                }
            }
        ]
    }
];
